// hooks
import useAuth from '../hooks/useAuth';
//
import { MAvatar } from './@material-extend';
import createAvatar from '../utils/createAvatar';
import { getLastName } from '../utils/getLastName';
import { Avatar } from '@material-ui/core';

// ----------------------------------------------------------------------

export default function MyAvatar({ nameStaff, fontSize, width, height, ...other }) {
  const { user } = useAuth();
  const stringAvatar = (name) => {
    return {
      sx: {
        bgcolor: '#303187',
        fontSize: fontSize ? fontSize : '20px',
        lineHeight: '24px',
        fontWeight: '700',
        fontStyle: 'normal',
        color: '#FFFFFF;',
        border: '1px solid white',
        width: width ? width : '40px',
        height: height ? height : '40px'
      },
      // children: `${name.split(' ')[0][0]}${name.split(' ')[1][0]}`,
      children: `${name.toUpperCase().split('')[0]}`,
    };
  }
  return (
    <Avatar {...stringAvatar(nameStaff ? nameStaff : user ? user.full_name : "voip24h")}></Avatar>
    // <MAvatar
    //   src={user?user.photoURL:"null"}
    //   alt={user?user.full_name:"voip24h"}
    //   // color={user ? 'default' : createAvatar(user?getLastName(user.full_name):"voip24h").color}
    //   {...other}
    // >
    //   {createAvatar(user?getLastName(user.full_name):"voip24h").name}
    // </MAvatar>
  );
}
